import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/settings/company_store_settings/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/settings/company_store_settings';

const Home: NextPage = () => (
  <>
    <NskHead title="店舗項目設定" />
    <Component />
  </>
);

export default Home;
